export type Package = {
  'id': number,
  'order_id': number
  'username_id': number,
  'package_id': number,
  'params': string,
  'start_date': string,
  'created_at': string,
  'end_date': string,
  'valid': number,
  'price': string,
  'auto_renew': number,
  'soglia_web': number,
  'soglia_mobile': number,
  'title': string
};

type Packages = {
  result: {
    code: string,
    msg: string,
    data: {
      user_packages: Package[]
    }
  },
  status: string
};

export async function getUserPackages(accessToken: string): Promise<Packages | any> {
  const fetchUrl = `${process.env.REACT_APP_SSO_API_URL}/api/v1/user_packages_from_user`;
  try {
    const res = await fetch(fetchUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((data) =>  {
      return data.json();
    });
    return res;
  } catch (error) {
    return error;  
  }
}